import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4 bg-navy-900" data-id="element-47">
      <div className="max-w-3xl mx-auto bg-navy-800 rounded-2xl border border-gold-500/30 p-6 md:p-8" data-id="element-48">
        <div className="flex items-start gap-5" data-id="element-49">
          <div className="w-16 h-16 flex-shrink-0 bg-gold-500/10 rounded-full flex items-center justify-center border-2 border-gold-500/20" data-id="element-50">
            <ShieldCheck className="w-8 h-8 text-gold-400" data-id="element-51" />
          </div>
          <div data-id="element-52">
            <div className="text-gold-400 font-bold text-xs uppercase tracking-widest mb-1" data-id="element-53">
              Garanzia 30 Giorni
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-54">
              Soddisfatti o rimborsati al 100%
            </h3>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed" data-id="element-55">
              Prova il MegaPack per 30 giorni. Se non sei soddisfatto, rimborso
              completo senza domande.
            </p>
            <div className="flex flex-wrap gap-x-4 gap-y-1" data-id="element-56">
              {['Zero rischi', 'Rimborso 100%', 'Senza domande', 'Via email'].map((item, i) => <span key={i} className="flex items-center gap-1.5 text-gray-400 text-xs" data-id="element-57">
                  <Check className="w-3.5 h-3.5 text-brand-green" data-id="element-58" />
                  {item}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}